export default __webpack_public_path__ + "static/media/mastercard.6264393d.svg";